<template>
  <page-content v-has-permission.notify="'config_warehouse_shop_ff_view'">

    <panel ref="searchFormPanel" show-close show-collapse title="Thông tin tìm kiếm" :is-open.sync="openSearch">
      <c-form ref="searchForm" @submit="search()">
        <c-input v-model.trim="searchForm.shopCodes" form-group-class="col-md-6 col-sm-6"
                 label="Mã shop"
                 placeholder="Nhập nhiều mã shop thì ngăn cách nhau bằng dấu phảy hoặc khoảng trống. VD: S1 S2 hoặc S1, S2"
                 :validate-rules="!searchForm.shopCodes && !searchForm.stationId ? 'required' : '' "
        />
        <c-select2 v-model.number="searchForm.stationId"
                   label="Kho Fulfillment"
                   placeholder="Nhập tên kho"
                   uri="cms/api/v1.0/select2/all-station"
                   form-group-class="col-md-6 col-sm-6"
                   :validate-rules="!searchForm.shopCodes && !searchForm.stationId ? 'required' : '' "
        />

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success btn-sm" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>

            <button class="btn btn-secondary btn-sm" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>

            <b-button v-if="hasPermission('config_warehouse_shop_ff_create')"
                      size="sm"
                      variant="success"
                      @click="$refs.formCreate.open()"
            >
              <i class="fas fa-plus-circle"></i> Thêm cấu hình kho
            </b-button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel"
           show-collapse
           title="Danh sách các kho FF của shop"
           v-show="showResult"
    >
      <template #btn>
        <li>
          <a v-b-tooltip.hover class="" title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="openSearch = !openSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :lazy="true"
               :data-filter="dataFilter"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã shop', sortField:'shopCode', sortable: true},
                   {text: 'Tên shop', sortField:'shopName', sortable: true},
                   {text: 'Tên kho', sortField:'name', sortable: true},
                   {text: 'Thao tác FF', sortField:'inFf', sortable: true, width: '140px'},
                   {text: 'Thao tác Ecom', sortField:'inEcom', sortable: true, width: '140px'},
               ]"
               uri="cms/api/v1.0/shop-warehouse/get-all"
      >
        <template #button>

        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.shopCode }}</td>
          <td>{{ item.shopName }}</td>
          <td>{{ item.name }}</td>
          <td class="text-center">
            <b-button
                v-if="hasPermission('config_warehouse_shop_ff_create') && item.inFf !== 1 "
                class="btn btn-icon btn-success"
                title="Cấu hình lưu kho FF"
                type="button"
                @click="openCreateQuick(item)"
            >
              <i class="fas fa-warehouse-alt"></i>
            </b-button>

            <b-button
                v-if="hasPermission('config_warehouse_shop_ff_update') && item.inFf === 1 "
                class="btn btn-icon btn-warning"
                title="Thay đổi kho FF"
                type="button"
                @click="update(item)"
            >
              <i class="fas fa-exchange"></i>
            </b-button>

            <button
                v-if="hasPermission('config_warehouse_shop_ff_delete') && item.inFf === 1 "
                class="btn btn-icon btn-danger"
                title="Bỏ lưu kho FF"
                type="button"
                @click="confirmDelete(item)"
            >
              <i class="fas fa-minus-octagon"></i>
            </button>
          </td>
          <td class="text-center">
            <b-button
                v-if="hasPermission('config_warehouse_shop_ff_update') && item.inEcom !== 1"
                class="btn btn-icon btn-success"
                title="Đồng bộ lại sang Ecom"
                type="button"
                @click="createEcom(item)"
            >
              <i class="fad fa-sync-alt"></i>
            </b-button>

            <b-button
                v-if="hasPermission('config_warehouse_shop_ff_update') && item.inEcom === 1"
                class="btn btn-icon btn-danger"
                title="Xóa cấu hình trên Ecom"
                type="button"
                @click="removeEcom(item)"
            >
              <i class="fas fa-minus-octagon"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>


    <warehouse-add ref="formCreate" @success="search()"/>
    <warehouse-add-quick ref="formCreateQuick" @success="search()"/>
    <warehouse-update ref="formUpdate" @success="search()"/>
    <warehouse-confirm-delete ref="confirmDeleteDialog" @success="search()"/>


  </page-content>
</template>

<script>
import WarehouseAdd from "@/pages/Config/Warehouse/warehouse-add";
import WarehouseUpdate from "@/pages/Config/Warehouse/warehouse-update";
import WarehouseConfirmDelete from "@/pages/Config/Warehouse/WarehouseConfirmDelete";
import WarehouseAddQuick from "@/pages/Config/Warehouse/warehouse-add-quick";

export default {
  name: "Index",
  components: {WarehouseAddQuick, WarehouseConfirmDelete, WarehouseUpdate, WarehouseAdd},
  data() {
    return {
      searchForm: {
        shopCodes: null,
        stationId: null,
      },
      openSearch: true,
      showResult: false,
    }
  },
  computed: {
    dataFilter() {
      return {
        "shopCodes": this.searchForm.shopCodes ? this.searchForm.shopCodes.split(/[\s,]+/) : [],
        "stationIds": this.searchForm.stationId ? [this.searchForm.stationId] : [],
      }
    }
  },
  mounted() {
  },
  methods: {
    search() {
      this.$refs.table.reload()
          .then(x => {
            this.showResult = true;
          });
    },
    resetFormSearch() {
      this.searchForm.shopCodes = null;
      this.searchForm.stationId = null;
      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    confirmDelete(item) {
      this.$refs.confirmDeleteDialog.open(item);
    },
    openCreateQuick(item) {
      this.$refs.formCreateQuick.open(item);
    },
    createEcom(item) {
      this.$http.post('/thunder/services/ffm/shop', {
        "action": "create",
        "shop_code": item.shopCode,
        "station_id": item.stationId
      })
          .then(successRes => {
            let res = successRes.data;
            if(res.success){
              this.$success(res.message);
              this.search();
            } else {
              this.$error(res.message || 'Lỗi xảy ra');
            }
          }, errorRes => {
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes))

            ;
            this.$emit("error", errorRes);
          })
    },
    removeEcom(item) {
      this.$http.post('/thunder/services/ffm/shop', {
        "action": "remove",
        "shop_code": item.shopCode,
        "station_id": item.stationId
      })
          .then(successRes => {
            let res = successRes.data;
            if(res.success){
              this.$success(res.message);
              this.search();
            } else {
              this.$error(res.message || 'Lỗi xảy ra');
            }
          }, errorRes => {
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes))

            ;
            this.$emit("error", errorRes);
          })
    },
  }
}
</script>

<style scoped>

</style>